/*
 * Inka — botón "+" de la tarjeta (snippets/inka-product-card.liquid).
 * Contrato: al pulsar [data-inka-quick-add] se emite en document
 *   new CustomEvent('inka:quick-add', { detail: { handle, variantId, hasVariants, button } })
 * y no se hace nada más. El panel de añadir rápido (agente E) escucha ese evento.
 * Delegado en document: sirve para tarjetas renderizadas después (secciones, búsquedas).
 */
(() => {
  if (window.__inkaCardBound) return;
  window.__inkaCardBound = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('[data-inka-quick-add]');
    if (!(button instanceof HTMLElement)) return;

    // El botón vive dentro del enlace de la tarjeta: nunca navega.
    event.preventDefault();
    event.stopPropagation();

    if (button.getAttribute('aria-disabled') === 'true') return;

    const variantId = Number(button.dataset.variantId) || null;
    document.dispatchEvent(
      new CustomEvent('inka:quick-add', {
        detail: {
          handle: button.dataset.productHandle || '',
          variantId,
          hasVariants: button.dataset.hasVariants === 'true',
          button,
        },
      })
    );
  });
})();
